import { render, staticRenderFns } from "./FramesInput.vue?vue&type=template&id=fa96741e&scoped=true&"
import script from "./FramesInput.vue?vue&type=script&lang=js&"
export * from "./FramesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa96741e",
  null
  
)

export default component.exports